import { apiGateway } from "@/shared/apiGateway";

const getUserListing = context => {
  return apiGateway
    .apiGatewayGET("api/users/")
    .then(data => {
      return context.commit("Set_User_Listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Users"], {
        root: true
      });
    });
};

const getUserDetail = (context, emailAddress) => {
  return apiGateway
    .apiGatewayGET("api/users/" + emailAddress)
    .then(data => {
      context.commit("Set_User", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting User"], {
        root: true
      });
    });
};

const createUser = (commit, { user }) => {
  return apiGateway.apiGatewayPOST("api/users?", user).then(data => {
    return data;
  });
};

const updateUser = (commit, { form }) => {
  return apiGateway.apiGatewayPUT("api/users/", form).then(data => {
    return data;
  });
};

const deleteUser = (context, emailAddress) => {
  return apiGateway.apiGatewayDELETE("api/users/" + emailAddress).then(() => {
    return;
  });
};

export default {
  createUser,
  deleteUser,
  getUserDetail,
  getUserListing,
  updateUser
};
